import { BaseModelActive } from '../../../shared/base/base.models';
import { PointOfSale } from '../points-of-sale/points-of-sale.models';
import { BusinessPartner, PolicyUserType } from '../rebate-policies/rebate-policies.models';
import { PaymentMethod } from '../payment-methods/payment-methods-models';
import { MeanOfDelivery } from '../means-of-delivery/means-of-delivery.models';
import { TaxRate } from '../tax-rate/tax-rate.models';

export class CostPolicy extends BaseModelActive {
    documentNumber?: string;
    validFrom?: Date;
    validTo?: Date;
    pointOfSale?: PointOfSale | string;
    businessPartner?: BusinessPartner | string;
    description?: string;
    type?: CostPolicyType | string;
    userType?: PolicyUserType | string;
    orderValueFrom?: number;
    orderValueTo?: number;
    meansOfDelivery?: MeanOfDelivery | string;
    paymentMethod?: PaymentMethod | string;
    value?: number;
    taxRate?: string | TaxRate;
}

export enum CostPolicyType {
    PAYMENT_METHOD, MEANS_OF_DELIVERY, ADMINISTRATIVE_COST
}